"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bootstrap5_1 = __importDefault(require("@ariform/bootstrap/bootstrap5"));
exports.default = {
    bootstrap: bootstrap5_1.default.templates.bootstrap5
};
